module.exports = "<iframe style=\"height: 100%; position: fixed; width: 100%;\" [src]=\"landing_url | safeUrl\" frameborder=\"0\" allowfullscreen></iframe>"